import { Fragment, useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useQuery } from 'packages/core'
import withRequiredData from './withRequiredData'
import { PageContextProvider } from 'pageContext'
import { useAllApplications } from 'hooks'
import { AppLayout } from 'components'
import config from 'config'
import { RequestViewAllCsvInbox } from 'containers/ViewAllCsvInbox'

import useSubcomponents from 'useSubcomponents'
import { useRouteOptions } from 'hooks'

import { IdleTimer } from 'packages/eid-ui'
import { useSessionTimeout } from 'hooks'

const App = () => {
    const query = useQuery()

    const { data: loginSessionTimeout } = useSessionTimeout()
    const { data: allowedApps, isLoading } = useAllApplications()

    const { trimPagesBasedOnAccess } = useSubcomponents()

    const { routeOptions, isLoading: routesLoading } = useRouteOptions()
    const allowedRoutes = trimPagesBasedOnAccess(routeOptions).filter(
        (route) => route.hidePage !== true,
    )
    const defaultRoute =
        allowedRoutes && allowedRoutes.length > 0
            ? allowedRoutes[0].route
            : null

    if (routesLoading) {
        return null // Or return a loader if needed
    }

    return (
        <Fragment>
            <Switch>
                {/* Render routes for all allowed routes (including "all" and each inbox type) */}
                {allowedRoutes.map((route) => (
                    <Route
                        key={route.name}
                        exact
                        path={`${config.APP_SUBPATH}${route.route}/`}
                        render={(props) => (
                            <PageContextProvider
                                key={`RequestViewAll-${route.name}`}
                            >
                                <RequestViewAllCsvInbox {...props} />
                            </PageContextProvider>
                        )}
                    />
                ))}

                <Route exact path={`${config.APP_SUBPATH}/`}>
                    {defaultRoute ? (
                        <Redirect to={`${config.APP_SUBPATH}${defaultRoute}`} />
                    ) : (
                        <Redirect
                            from=""
                            to={`${config.APP_SUBPATH}/notfound`}
                        />
                    )}
                </Route>
                <Redirect from="" to={`${config.APP_SUBPATH}/notfound`} />
            </Switch>
            {loginSessionTimeout && !isLoading && (
                <IdleTimer
                    loginSessionTimeout={loginSessionTimeout}
                    allowedUrls={allowedApps}
                />
            )}
        </Fragment>
    )
}

export default withRequiredData(App)
